import type { ReactNode } from "react";
import { Link } from "@tanstack/react-router";
import dashboardIcon from "../assets/icons/dashboard.svg";
import { PrimeGlyph } from "./PrimeGlyph";

// PORT OF `_common/breadcrumb` (`p-breadcrumb` WITH THE PILLARS OVERRIDE): NO
// BACKGROUND, 0 0 14PX PADDING; A 17.5PX DASHBOARD ICON LINKING HOME, 14PX CHEVRONS
// WITH 7PX MARGINS IN `#6c757d`, EARLIER ITEMS AS `#007bff` LINKS, THE LAST IN `#6c757d`. THE DARK
// THEME USES `#8dd0ff` LINKS AND NEAR-WHITE FOR THE REST (`--pillars-crumb-*` TOKENS).
// `actions` IS THE RIGHT-HAND SIDE OF THE PAGE'S BREADCRUMB ROW.
export interface Crumb {
  label: string;
  to?: string;
}

export function Breadcrumb({ items, actions }: { items: Crumb[]; actions?: ReactNode }) {
  return (
    <div className="flex flex-row align-items-center justify-content-between">
      <nav aria-label="Breadcrumb" className="max-w-full" style={{ overflowX: "auto", padding: "0 0 1rem 0" }}>
        <ol className="flex align-items-center flex-nowrap m-0 p-0" style={{ listStyle: "none" }}>
          <li>
            <Link to="/" aria-label="Dashboard" className="flex align-items-center border-round">
              <img src={dashboardIcon} alt="" style={{ width: "1.25rem", height: "1.25rem" }} />
            </Link>
          </li>
          {items.map((c, i) => {
            const last = i === items.length - 1;
            return (
              <li key={c.label} className="flex align-items-center">
                <span className="flex align-items-center" style={{ margin: "0 0.5rem", color: "var(--pillars-crumb-text)" }}>
                  <PrimeGlyph name="chevron-right" />
                </span>
                {c.to && !last ? (
                  <Link to={c.to} style={{ color: "var(--pillars-crumb-link)", lineHeight: 1 }}>
                    {c.label}
                  </Link>
                ) : (
                  <span aria-current={last ? "page" : undefined} style={{ color: "var(--pillars-crumb-text)", lineHeight: 1 }}>
                    {c.label}
                  </span>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
      {actions}
    </div>
  );
}
